<template>
    <div>
        <div class="columns is-centered">
            <div class="column has-text-centered">
                <h1 class="is-size-3 has-text-white">Reporting</h1>
                <div class="box has-background-dvodark mb-0">
                  <b-field grouped>
                    <b-datepicker
                        placeholder="Enter a date range"
                        v-model="dates"
                        range>
                    </b-datepicker>
                    <b-button type="is-primary" inverted outlined class="ml-2" @click="getWarranties">                     
                          Get Results
                    </b-button> 
                    <reports-filter-dropdown class="ml-2" @myEmit="changeFilterCriteria"/>
                    <download-csv
                          :data  = "warranties"
                          class="button is-primary ml-2"
                          >
                        <b-icon icon="file-excel">
                        </b-icon>
                        <span>
                        Export
                        </span>                    
                    </download-csv>                
                  </b-field>
              </div>
              <b-table :data="warranties" paginated :per-page="10" :current-page.sync="currentPage"
                  :pagination-simple="false" pagination-position="bottom" striped :loading="isLoading">
                  <b-table-column field="submitted" label="Date Submitted"  sortable width="40" v-slot="props">
                      <span v-if="props.row.submitted" class="tag is-warning">
                            {{ new Date(props.row.submitted).toLocaleDateString() }}
                      </span>
                  </b-table-column>
                  <b-table-column field="warranty_id" label="Warranty ID" width="40" v-slot="props">
                        <p>
                            {{props.row.warranty_id}}
                        </p>
                  </b-table-column>
                  <b-table-column field="reference_number" label="Reference #" width="40" v-slot="props">
                      {{ props.row.reference_number }}
                  </b-table-column>
                  <b-table-column field="serial_id" label="Item To Repair" width="40" v-slot="props">
                      {{ props.row.serial_id }}
                  </b-table-column>
                  <b-table-column field="total" label="Total" width="40" v-slot="props" sortable>
                    ${{props.row.total}}
                  </b-table-column>
                  <b-table-column field="approved" label="Approval" width="40">
                    <template v-slot="props">{{props.row.approved}}</template>
                  </b-table-column>
                <template #empty>
                    <div class="has-text-centered">No records</div>
                </template>
              </b-table>                
            </div>
        </div>
    </div>
</template>

<script>
import { API  } from 'aws-amplify'
import { warrantyReader, getWarrantyFilteredPlus } from '../graphql/queries'
import ReportsFilterDropdown from './ReportsFilterDropdown.vue'
export default {
    components: {
      ReportsFilterDropdown,
    },
    data(){
        return{
            currentPage: 1,
            warranties: [],
            isLoading: false,
            dates: [],
            filter: []  
        }
    },
    computed: {
      isFiltered(){
      if(this.filter.length > 0){
        return true
        } else {
          return false
        }
      }

    },
    methods:{
    convertDate(date){
      console.log(date)
      const offset = new Date().getTimezoneOffset()
      let returnVal = new Date(date.getTime() - (offset*60*1000))
      return returnVal.toISOString().split('T')[0]
    },
    changeFilterCriteria(firstFilterCritiera, filterCritiera){
      this.filter = []
      this.filter = firstFilterCritiera 
      this.filter = firstFilterCritiera.concat(filterCritiera)
    },
    getLastMonth(){
      var x = new Date();
      x.setDate(1);
      x.setMonth(x.getMonth()-1);
      return x
    },
    async getWarranties(){
    this.isLoading = true;

    if(this.dates.length === 0){
      try {
            const Warranties = await API.graphql({
                query: warrantyReader,
                    variables: {
                        input: {
                          request_type: 'read_all'
                        }
                    }
        });
      this.warranties = Warranties.data.warrantyReader
      } catch (e) {
        console.log(e)
            this.$buefy.notification.open({
            duration: 5000,
            message: `${e}`,
            position: 'is-bottom',
            type: 'is-danger',
            hasIcon: true
        })
      }
    } else {
      try {
        console.log('hi')
        console.log(this.filter)
            const Warranties = await API.graphql({
                query: getWarrantyFilteredPlus,
                    variables: {
                        input: {
                          request_type: 'filtered_plus_read',
                          start_date: this.convertDate(this.dates[0]),
                          end_date: this.convertDate(this.dates[1]),
                          filter: this.filter
                        }
                    }
        });

      console.log(Warranties.data.getWarrantyFilteredPlus)
      this.warranties = Warranties.data.getWarrantyFilteredPlus
      } catch (e) {
          console.log(e)
              this.$buefy.notification.open({
              duration: 5000,
              message: `${e}`,
              position: 'is-bottom',
              type: 'is-danger',
              hasIcon: true
          })
      }
    }
    this.isLoading = false
    }
    },
  mounted(){
    let date = new Date()
    this.dates = [date, date]
    this.getWarranties();
  }    
}
</script>

<style>

</style>